import PassageCard from "./PassageCard";

export default PassageCard;
